<template>
    <div class="chapter flex flex-column" v-if="chapter" :key="chapter.chapter_id">
        <header class="bc">
            <nav class="flex flex-align">
                <router-link class="wordmark" :to="{name: 'product.contents'}">
                    <img src="@/assets/logo.svg" class="logo" />
                </router-link>
                <router-link class="breadcrumb" :to="{name: 'product.contents'}">{{product.product_title}}</router-link>
                <a class="breadcrumb" @click="change">
                    <span v-if="chapter.chapter_number">{{chapter.chapter_number}}</span>
                    {{chapter.chapter_title}}
                </a>
            </nav>
            <!-- <h2 v-if="chapter.chapter_description">{{chapter.chapter_description}}</h2> -->
        </header>
        <div class="chapter-assign flex flex-align" v-if="chapter.chapter_questions">
            <div class="chapter-warning ff">
                You are currently viewing an assignment. Use the button on the right to send it to your students.
            </div>
            <div @click="assign" class="button white">Assign To Students</div>
        </div>
        <div class="ff flex">
            <main class="ff" ref="main" :class="{sidebar: chapter.chapter_simulation}">
                <div class="chapter-constraint bc">
                    <article>
                        <h1>{{chapter.chapter_title}}</h1>
                        <template v-for="child of chapter.component_children">
                            <components v-if="child.component_type !== 'string'" :configuration="child" v-bind="child.component_data" :key="child.component_id" />
                            <template v-else>{{child.component_content.trim()}}</template>
                        </template>
                    </article>
                    <footer>
                        <div class="flex flex-align">
                            <router-link class="ff chapter-direction chapter-previous flex flex-align" :to="{params: {chapter: previous.chapter_id}}" v-if="previous">
                                <div class="ff">
                                    <h4>Previously</h4>
                                    <h3>{{previous.chapter_title}}</h3>
                                </div>
                                <div class="chapter-next-arrow"></div>
                            </router-link>
                            <router-link class="ff chapter-direction chapter-next flex flex-align" :to="{params: {chapter: next.chapter_id}}" v-if="next">
                                <div class="ff">
                                    <h4>Next Up</h4>
                                    <h3>{{next.chapter_title}}</h3>
                                </div>
                                <div class="chapter-next-arrow"></div>
                            </router-link>
                        </div>
                        <div class="disclaimer center">
                            Download the text for free at <a target="_blank" :href="product.product_source_url">OpenStax</a>.
                        </div>
                    </footer>
                </div>
            </main>
            <div class="chapter-simulation" v-if="chapter.chapter_simulation" :key="chapter.chapter_id" :style="backgroundImage()">
                <simulation ref="simulation" :root="true" v-show="!isAnatomy || activeSimulation" />
            </div>
        </div>
    </div>
</template>

<script>
    import Chapters from '@/components/modals/Chapters.vue';
    import Assign from '@/components/modals/Assign.vue';

    export default {
        name: 'Chapter',
        data(){
            return {
                loading: false
            };
        },
        methods: {
            change(){
                this.$modal.show(Chapters, {}, {width: 800, height: 600, classes: 'modal'});
            },
            assign(){
                this.$modal.show(Assign, {chapter: this.chapter}, {width: 700, height: 'auto', classes: 'modal'});
            },
            load(){
                this.loading = true;

                if(!this.product){
                    return;
                }

                if(!this.active){
                    return;
                }

                this.$store.dispatch('products/contents')
                .then(() => this.$store.dispatch('chapters/load', {
                    product_id: this.product.product_id,
                    chapter_id: this.active
                }))
                .then(() => {
                    this.$refs.main.scrollTop = 0;
                })
                .catch(() => this.$toasted.error('There was an error loading the requested chapter.'))
                .finally(() => this.loading = false);
            },
            backgroundImage(){
                let bgImageStyle = null
                const splashImagePath = '/assets/0376b7fc-4f04-4406-a58c-996c87ece1a8/splash-screen-renders';

                if(this.chapter.chapter_simulation && this.isAnatomy) {
                    const chapter = this.chapter.chapter_number.match('^([^.]+)');
                    const imagePath = `${splashImagePath}/Ch${chapter[0]}_render.png`;
                    bgImageStyle = {
                        backgroundImage: `url(${imagePath})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        transition: 'background-image .5s linear'
                    };
                }

                return bgImageStyle
            },
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            chapter(){
                return this.$store.getters.chapter;
            },
            user(){
                return this.$store.state.user;
            },
            active(){
                return this.$route.params.chapter;
            },
            next(){
                if(this.chapter){
                    console.log('Chapter', this.chapter);
                    console.log('Contents', this.$store.state.products.contents[this.chapter.chapter_id]);
                    return this.$store.state.products.contents[this.chapter.chapter_id].next;
                }
            },
            previous(){
                if(this.chapter){
                    return this.$store.state.products.contents[this.chapter.chapter_id].previous;
                }
            },
            isAnatomy(){
                return this.product.product_slug === 'anatomy';
            },
            isAstronomy(){
                return this.product.product_slug === 'astronomy';
            },
            activeSimulation(){
                return this.$store.state.chapters.simulation
            }
        },
        created(){
            //Activate a product based on the URL slug.
            const product = this.$store.getters.products.find(product => product.product_slug === this.$route.params.product);

            if(product){
                this.$store.dispatch('products/activate', product).then(() => this.load());
            }
        },
        watch: {
            active: {
                immediate: true,
                handler(){
                    this.load();
                }
            },
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .chapter
    {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .chapter-assign
    {
        height: 50px;
        background: @base;
        color: @white;
        padding: 0 10px 0 20px;

        .chapter-warning
        {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .button
        {
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            font-size: 13px;
            color: @base;
        }
    }

    article
    {
        h1
        {
            margin: 80px 50px 30px;
            // font-size: 36px;
            // line-height: 44px;
        }
    }

    main
    {
        min-width: 450px;
        overflow-y: auto;
    }

    .chapter-constraint
    {
        max-width: 800px;
    }

    header
    {
        padding: 8px 10px;
        width: 100%;
        border-bottom: 1px solid var(--border-color);

        .wordmark
        {
            font-size: 18px;
            font-weight: 500;
            display: block;

            .logo
            {
                height: 26px;
                display: block;
            }
        }

        h2
        {
            margin-top: 20px;
            font-weight: 500;
        }

        hr
        {
            margin: 50px 0 0;
            height: 1px;
            border: 0;
            background: #333;
        }

        .breadcrumb
        {
            font-size: 14px;
            color: var(--primary-text-color);
            font-weight: 500;
            margin: 0 0 0 30px;
            cursor: pointer;
            border-radius: 3px;
            padding: 0 5px;
            line-height: 26px;

            &:hover, &:active
            {
                background-color: var(--primary-text-color);
                color: var(--background-color);
            }

            &::before
            {
                width: 12px;
                height: 12px;
                content: "";
                position: absolute;
                left: -21px;
                top: 9px;
                background: url('~@/assets/icons/white/caret-down.svg') 1px 1px no-repeat;
                background-size: 14px auto;
                transform: rotate(-90deg);
            }
        }
    }

    .chapter-simulation
    {
        flex: 2;
        background: #111;
        border-left: 1px solid var(--border-color);
    }

    .chapter-direction
    {
        margin: 50px 0 50px 20px;
        border: 1px solid @black;
        background: var(--input-background-color);
        border-radius: 3px;
        padding: 20px;

        h3
        {
            color: var(--primary-text-color);
            font-size: 24px;
        }

        h4
        {
            color: @base;
            font-weight: 500;
            font-size: 12px;
        }

        .chapter-arrow
        {
            width: 24px;
            height: 24px;
            background: url('~@/assets/icons/grey/arrow-right.svg') center center no-repeat;
            background-size: 24px auto;
            margin-left: 20px;
        }

        &:hover, &:active
        {
            background: var(--background-color);
        }

        &:first-child
        {
            margin-left: 0;
        }
    }

    .disclaimer
    {
        margin: 50px;
        font-size: 12px;
        color: var(--secondary-text-color);

        a
        {
            color: @base;
        }
    }

    @media only screen and (max-width: 1100px)
    {
        main
        {
            min-width: 400px;
        }
    }
</style>
